/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_EmptyInputs */

const en_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No funnel data yet. Start applying to see your pipeline.`)
};

const de_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Funnel-Daten. Bewirb dich, um deine Pipeline zu sehen.`)
};

const fr_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune donnée d'entonnoir pour le moment. Commence à postuler pour voir ton pipeline.`)
};

const es_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay datos del embudo. Empiece a postularse para ver su pipeline.`)
};

const it_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun dato sull'imbuto ancora. Inizia a candidarti per vedere la tua pipeline.`)
};

const nl_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen trechtergegevens. Begin met solliciteren om je pipeline te zien.`)
};

const pl_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych o lejku. Zacznij aplikować, aby zobaczyć swoją pipeline.`)
};

const fi_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei vielä suppilon tietoja. Aloita hakeminen nähdäksesi putki.`)
};

const da_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tragtdata endnu. Begynd at ansøge for at se din pipeline.`)
};

const sv_analytics_funnel_empty = /** @type {(inputs: Analytics_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen trattdata ännu. Börja ansöka för att se din pipeline.`)
};

/**
* | output |
* | --- |
* | "No funnel data yet. Start applying to see your pipeline." |
*
* @param {Analytics_Funnel_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_empty = /** @type {((inputs?: Analytics_Funnel_EmptyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_EmptyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_empty(inputs)
	if (locale === "fr") return fr_analytics_funnel_empty(inputs)
	if (locale === "es") return es_analytics_funnel_empty(inputs)
	if (locale === "it") return it_analytics_funnel_empty(inputs)
	if (locale === "nl") return nl_analytics_funnel_empty(inputs)
	if (locale === "pl") return pl_analytics_funnel_empty(inputs)
	if (locale === "fi") return fi_analytics_funnel_empty(inputs)
	if (locale === "da") return da_analytics_funnel_empty(inputs)
	if (locale === "sv") return sv_analytics_funnel_empty(inputs)
	return en_analytics_funnel_empty(inputs)
});